// Блокировки раздела «Найм». Правило 10: блокировка называет причину и предлагает шаг, а
// «доступ запрещён» блокировкой не считается.
//
// Правило `.claude/rules/ui-views.md` жёстче, чем кажется: выключенная кнопка не доводит
// нажатие до обработчика, то есть человек жмёт и не получает НИЧЕГО — со стороны это
// неотличимо от сломанной программы. Поэтому кнопка остаётся нажимаемой, а отказ объясняется
// текстом. Здесь собраны обе половины этого: плашка над формой (чего не хватает ещё до
// заполнения) и текст отказа по нажатию.

import type { ReactNode } from 'react';

import { RiErrorWarningLine } from '@remixicon/react';

import { useAuthStore } from '@/shared/auth/store';
import { can } from '@/shared/rbac/permissions';
import * as Alert from '@/shared/ui/alert';
import * as Hint from '@/shared/ui/hint';

/** Есть ли право. Тонкая обёртка, чтобы формы найма не таскали стор поимённо. */
export function useCan(code: string): boolean {
  const permissions = useAuthStore((state) => state.permissions);
  return can(permissions, code);
}

/**
 * Плашка «права на это действие нет». Стоит НАД формой, а не появляется по нажатию: человек
 * узнаёт об отказе до того, как заполнит семь полей, а не после.
 *
 * `что` — действие словами от первого лица дела: «менять этап воронки», «вносить записи».
 * `кто` — кому оно поручено по матрице тз: рядом с отказом обязан стоять адрес, куда идти.
 */
export function NoPermissionNote({ что, кто }: { что: string; кто: string }) {
  return (
    <Alert.Root variant='light' status='warning' size='small' role='status'>
      <Alert.Icon as={RiErrorWarningLine} />
      <span>
        Права {что} у вас нет: форму можно заполнить, но действие не пройдёт. {кто}
      </span>
    </Alert.Root>
  );
}

/** Причина отказа по нажатию: то, что было бы молчанием у выключенной кнопки. */
export function GateNote({ children }: { children: ReactNode }) {
  return (
    <Hint.Root hasError>
      <Hint.Icon as={RiErrorWarningLine} />
      {children}
    </Hint.Root>
  );
}
